import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de médico). */
export type CertificadoInscricaoPjJob = ReportJob;
export type CertificadoInscricaoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Inscrição PJ. */
@Injectable({ providedIn: 'root' })
export class CertificadoInscricaoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certificado-inscricao-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certificadoInscricaoPj;
}
